const equipoAdminRutes = [
  {
    path: '/ds/equipo-admin/:idTeam',
    component: () => import('../views/teamAdmin/IndexTeamAdminPage.vue'),
    meta: {requiresAuth: true},
    children: [
      {
        path: '',
        component: () => import('../views/teamAdmin/TeamPageAdmin.vue'),
        children: [
          {
            path: 'info',
            name: 'team-page-admin',
            component: () => import('../views/teamAdmin/InfoTeamAdminPage.vue'),
          },
        ]
      },
      {
        path: 'partidos',
        name: 'team-partidos-admin',
        component: () => import('../views/teamAdmin/ProximosPartidosTeamAdminPage.vue'),
      },
      {
        path: 'ficha/:idMatch',
        name: 'team-ficha-admin',
        component: () => import('../views/teamAdmin/FichaMatchTeamAdminPage.vue'),
      },
      {
        path: 'news',
        name: 'team-news-admin',
        component: () => import('../views/teamAdmin/NewsTeamAdminPage.vue'),
      },
      {
        path: 'reportes',
        name: 'team-reportes-admin',
        component: () => import('../views/teamAdmin/ReportesTeamAdminPage.vue'),
      },
      {
        path: 'pizarra',
        name: 'team-pizarra-admin',
        component: () => import('../views/teamAdmin/PizarraTeamAdminPage.vue'),
      },
      {
        path: 'plantel/:idIns',
        name: 'team-plantel-admin',
        component: () => import('../views/teamAdmin/PlatelTeamAdminPage.vue'),
      },
    ]
  },
]

export default equipoAdminRutes
